import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {LegendInterface} from '../report-general.component';

@Component({
  selector: 'pas-legend',
  standalone: true,
  imports: [],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LegendComponent {
@Input({required: true}) legend!:LegendInterface

}
